var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "home-intro-toggle" }, [
    _c("div", { staticClass: "home-intro-toggle--wrap" }, [
      _c(
        "button",
        {
          staticClass: "home-intro-toggle--btn btn btn__bubble btn__light",
          on: { click: _vm.onHomeIntroCloseRequested }
        },
        [
          _c("cmp-icon", {
            staticClass: "home-intro-toggle--icon",
            attrs: {
              symbol: "chevron-down",
              size: "small",
              "dynamic-size": true
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36e6ed2b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36e6ed2b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./vehi-industriepfad/assets/src/js/app/framework/components/home-intro-toggle/index.vue
// module id = 356
// module chunks = 5